// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { wishListSharingStatusStyles } from "@guestsupply/Overrides/Components/WishListSharingStatus";
import { color } from "@guestsupply/XDL/Utilities";
import Users from "@insite/mobius/Icons/Users";
import { css } from "styled-components";

wishListSharingStatusStyles.privateTooltip = {
    mergeCss: true,
    iconProps: {
        size: 13,
    },
    cssOverrides: {
        tooltipClickable: css`
            &&& {
                margin-right: 5px;
                display: flex;
            }
        `,
    },
};

wishListSharingStatusStyles.statusText = {
    css: css`
        &&& {
            margin: 0;
            display: flex;
            align-items: baseline;
            > span {
                display: flex;
                align-items: center;
            }
        }
    `,
};

wishListSharingStatusStyles.sharedIcon = {
    src: Users,
    size: 15,
    css: css`
        margin-right: 5px;
        svg {
            color: ${color("common.ui8")};
        }
        &:hover {
            svg {
                color: ${color("text.link")};
            }
        }
    `,
};

wishListSharingStatusStyles.autoGeneratedprivateTooltip = {
    mergeCss: true,
    iconProps: {
        size: 13,
    },
    cssOverrides: {
        tooltipClickable: css`
            &&& {
                margin-left: 5px;
            }
        `,
    },
};
